import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    memberId: Yup.string()
        .required('Member ID is required')
        .matches(/^[0-9]+$/, 'Member ID must contain only numbers')
        .test('min', 'Member ID must be at least 1', value => parseInt(value, 10) >= 1)
        .test('max', 'Member ID must be at most 999999', value => parseInt(value, 10) <= 999999)
});